import { Component, OnInit, OnDestroy, ViewChild, Input, AfterViewInit, Renderer2 } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { AlertService, MessageSeverity } from '../../services/alert.service';
import { ICD, MasterConfig, ResponseAPI, ErrorList } from '../../models/IDPReport.model';
import { SfDataService } from '../../services/sf-data.service';
import { UserEdit } from '../../models/user-edit.model';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import Swal from 'sweetalert2';
import { Utilities } from '../../services/utilities';
import { ConfigurationService } from '../../services/configuration.service';

@Component({
    selector: 'app-sf-icd-changerequest',
    templateUrl: './sf-icd-changerequest.component.html',
    styleUrls: ['./sf-icd-changerequest.component.scss'],
    standalone: false
})
export class SfIcdChangerequestComponent implements OnInit, OnDestroy {

  @ViewChild(DataTableDirective, { static: false })
  datatableElement: DataTableDirective;
  dtOptions: any = {};
  NewCount: number = 0;
  WorkingCount: number = 0;
  CompletedCount: number = 0;
  OnHoldCount: number = 0;
  TotalCount: number = 0;
  ReadytoCloseCount: number = 0;
  isrepLoading = false;
  isLoading = false;
  // Insurance Update requests are hidden by default; the checkbox toggles them on.
  showInsuranceUpdates = false;
  private _unlistenDocClick: () => void;

  public userEdit: UserEdit;
  @Input()
  isViewOnly: boolean;

  @Input()
  isGeneralEditor = false;
  selectedFilter: string = '';

  // Searchable dropdown filters (populated from the loaded table rows).
  companyOptions: string[] = [];
  ownerOptions: string[] = [];
  requestOptions: string[] = [];
  selectedCompany: string = null;
  selectedOwner: string = null;
  selectedRequest: string = null;


  constructor(private alertService: AlertService, private sfDataService: SfDataService, private renderer: Renderer2, private router: Router, private configurations: ConfigurationService) { }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      });
    } catch {
      return dateString;
    }
  }

  generateTooltipContent(full: any): string {
    //console.log(full);
    return `
      <div class="case-tooltip-content">        
        <div style="font-size: 12px; line-height: 1.6;">
          <div><strong>Case No:</strong> ${full.caseNumber || 'N/A'}</div>
          <div><strong>Case Reason:</strong> ${full.reason || 'N/A'}</div>
          <div><strong>ICD Company:</strong> ${full.accountName || 'N/A'}</div>
          <div><strong>ICD Owner Name:</strong> ${full.accountOwnerName || 'N/A'}</div>
          <div><strong>Next Step:</strong> ${full.nextStep || 'N/A'}</div>
          <div style="margin-top: 8px; border-top: 2px solid #ddd; padding-top: 8px; font-weight: bold; margin-bottom: 8px;"><strong>COMPLETION DATES</strong></div>
          <div><strong>Request Submitted On:</strong> ${this.formatDate(full.createdDate)}</div>
          <div><strong>ICD Info Received On:</strong> ${this.formatDate(full.icdInfoReceivedOn)}</div>
          <div><strong>Hub Info Received On:</strong> ${this.formatDate(full.hubInfoReceivedOn)}</div>
          <div><strong>Acknowledgement Received On:</strong> ${this.formatDate(full.icdAckReceivedOn)}</div>
          <div><strong>Hub Info Reviewed On:</strong> ${this.formatDate(full.hubInfoReviewedOn)}</div>
          <div><strong>NC/PO Recommendation Sent On:</strong> ${this.formatDate(full.nC_PO_Recommendation_Sent_On__c)}</div>
          <div><strong>NC/PO Approval Received On:</strong> ${this.formatDate(full.nC_PO_Approval_Received_On__c)}</div>
          <div><strong>Dist & Service Agreement Sent On:</strong> ${this.formatDate(full.dist_and_Service_Agreement_Sent_On__c)}</div>
          <div><strong>Dist & Service Agreement Received On:</strong> ${this.formatDate(full.dist_and_Service_Agreement_Received_On__c)}</div>
          <div><strong>Insurance Confirmed On:</strong> ${this.formatDate(full.insurance_Confirmed_Date_Time__c)}</div>
          <div><strong>Distributor Code Issued On:</strong> ${this.formatDate(full.distributor_Code_Issued_On__c)}</div>
          <div style="margin-top: 8px; border-top: 1px solid #ddd; padding-top: 8px; font-size: 11px; color: #666;">
            ***Please Note Time Zone is PST***
          </div>
        </div>
      </div>
    `;
  }

  ngOnInit() {
    if (!this.isGeneralEditor) {

      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: this.configurations.defaultPageSize,
        lengthMenu: [10, 25, 50, 100],
        processing: true,
        // Re-bind the Next Step popovers after every redraw (sort, paging, search, filter),
        // since DataTables re-renders the cells and drops the previous bindings.
        drawCallback: () => {
          setTimeout(() => this.initializeTooltips(), 50);
        },
        ajax: (dataTablesParameters: any, callback) => {
          this.sfDataService.getCDReports().subscribe(resp => {
            //console.log(resp);
            //debugger;
            // Exclude specific case reasons from the list
            const excludedReasons = [
              'Org Status Review',
              'Sales Network Status Review'
            ];

            // Insurance Update requests are hidden unless the user opts in via the checkbox.
            if (!this.showInsuranceUpdates) {
              excludedReasons.push('Insurance Update');
            }

            const filteredResp = Array.isArray(resp)
              ? resp.filter((r: any) => {
                  const reason = (r && r.reason) ? String(r.reason).trim() : '';
                  return reason && !excludedReasons.includes(reason);
                })
              : resp;

            // Derive the card counts from the exact rows shown in the table (not a
            // separate aggregate query) so the cards always match "Showing X of Y entries".
            const rows = Array.isArray(filteredResp) ? filteredResp : [];
            const countByStatus = (status: string) =>
              rows.filter((r: any) => ((r?.status ?? '') as string).trim() === status).length;

            this.NewCount = countByStatus('New');
            this.WorkingCount = countByStatus('Working');
            this.OnHoldCount = countByStatus('On Hold');
            this.ReadytoCloseCount = countByStatus('Ready to Close');
            this.CompletedCount = rows.filter((r: any) => {
              const s = ((r?.status ?? '') as string).trim();
              return s === 'Closed' || s === 'Completed';
            }).length;
            this.TotalCount = rows.length;

            // Build the searchable dropdown option lists from the rows actually loaded
            // into the table, so each dropdown lists only values the user can see.
            this.companyOptions = this.distinctSorted(rows, 'accountName');
            this.ownerOptions = this.distinctSorted(rows, 'accountOwnerName');
            this.requestOptions = this.distinctSorted(rows, 'reason');

            callback({
              //recordsTotal: resp.recordsTotal,
              //recordsFiltered: resp.recordsFiltered,
              data: filteredResp
            });
            // this.alertService.showStickyMessage('Data loaded', '', MessageSeverity.info);
            $('.dt-buttons').addClass('pull-right');
            // initialize tooltips for rows rendered
            setTimeout(() => this.initializeTooltips(), 50);
          });
        },
        columns: [
          {
            title: 'Case Number',
            data: 'caseNumber'
          }
          ,
          {
            title: 'ICD Company Name',
            data: 'accountName'
          }
          , {
            title: 'ICD Owner Name',
            data: 'accountOwnerName'
          }
          , {
            title: 'Request',
            data: 'reason'
          }
          , {
            title: 'Request Status',
            data: 'status'
          }

          , {
            title: 'Next Step',
            data: 'nextStep',
            render: (data: any, type: any, full: any) => {
              return `<span class="next-step-tooltip" data-tooltip="${this.escapeHtml(JSON.stringify(full))}" title="Check SCI Next Data">${data || 'N/A'}</span>`;
            }
          }

          , {
            title: 'Created Date PST',
            data: 'createdDate'
          }
          , {
            title: 'Hub Manager',
            data: 'accountHubName'
          }
          , {
            title: 'Action',
            data: 'encyrptID',
            render: function (data: any, type: any, full: any) {
              // Insurance Update shows the step text (Next Step column) for information only —
              // it never gets an action button, so suppress all buttons for that reason.
              if (full.reason?.toLowerCase().includes('insurance update')) {
                return '';
              }
              if (full.nextStep == 'Step 2 : ICD Information Needed' || full.nextStep ==  'Step 4 : ICD Acknowledgement Needed') {
                return '<a encyrptidresend="' + full.encyrptID + '" class="btn btn-warning btn-sm" (click)="handleViewClickResend(\'' + full.encyrptID + '\')" encyrptidresend="' + full.encyrptID + '"><i class="fa fa-envelope-o"></i> Resend Email</a>';
              }

              else if (full.reason?.toLowerCase().includes('additional location') && full.status == 'New') {
                return '<a encyrptidl="' + full.encyrptID + '" class="btn btn-warning btn-sm" ><i encyrptidl="' + full.encyrptID + '" class="fa fa-pencil"></i> Open HJ Portal - Add Loc</a>';
              }
              else if (full.reason?.toLowerCase().includes('move') && full.status == 'New') {
                return '<a encyrptidm="' + full.encyrptID + '" class="btn btn-warning btn-sm" ><i encyrptidm="' + full.encyrptID + '" class="fa fa-pencil"></i> Open HJ Portal - Move Loc</a>';
              }

              else if (full.nextStep == 'Step 3 : Hub Info/ Herb Joy Package Needed' && full.onboarding_Step_3A_Complete__c == 'false') {
                return '<a encyrptid="' + full.encyrptID + '" class="btn btn-warning btn-sm" (click)="handleViewClick(\'' + full.encyrptID + '\')" encyrptid="' + full.encyrptID + '"><i encyrptid="' + full.encyrptID + '" class="fa fa-pencil"></i></a>';
              }
              else if (full.nextStep == 'Step 3 : Hub Info/ Herb Joy Package Needed' && full.campaigns != null ) {
                return '<a encyrptidd="' + full.encyrptID + '" class="btn btn-warning btn-sm" ><i encyrptidd="' + full.encyrptID + '" class="fa fa-pencil"></i> Open HJ Portal - Step 3</a>';
              }
             
              
              else {
                return '';
              }
            }
          }

        ],
        // Declare the use of the extension in the dom parameter
        dom: 'lBfrtip',
        order: [[0, 'dsc']],
        responsive: true,
        intiComplete: function (settings: any, json: any) {
          $('.dt-buttons').addClass('pull-right');
        },
        // Configure the buttons
        buttons: [
           
          { extend: 'excel', title: "CM", text: 'Export to Excel', className: 'btn btn-sm btn-success mb-2 pull-right' },
           
        ]
      };
    }
  }

  escapeHtml(text: string): string {
    const map: { [key: string]: string } = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, m => map[m]);
  }

  handleViewClick(encryptID: string) {
    // Perform the desired action, such as navigating to a new page
    this.router.navigate(['/icddetail/offcamp', encryptID]);
  }


  handleViewClickResend(encryptID: string) {
    this.isLoading = true;

    this.alertService.startLoadingMessage('', 'Data loading...');
    this.sfDataService.ReSendEmail(encryptID)
      .subscribe(
        data => {
          let responseAPI = new ResponseAPI();
          //responseAPI = data;
          // Assign the received data to the responseAPI object
          responseAPI = data;
          if (responseAPI.isSuccess && !responseAPI.isValidationError) {

            setTimeout(() => {
              this.alertService.showMessage('ICD', `Email Re-Sent Successfully`, MessageSeverity.success);
              this.alertService.stopLoadingMessage();
              this.isLoading = false;
              
              this.alertService.showStickyMessage('Email Re-Sent Successfully', "", MessageSeverity.success, "");
              
              this.ShowOTPpopup();
              
            }, 500);
          }
          else {

            let errors = new ErrorList();
            errors = responseAPI.data;
            //setTimeout(() => {
            this.alertService.showMessage('ICD', `Error while sending email`, MessageSeverity.error);
            this.alertService.stopLoadingMessage();
            this.isLoading = false;
            this.alertService.showStickyMessage('Unable to send email', errors.error.message, MessageSeverity.error, errors.error.errorCode);
             

            //}, 200);

          }

        },
        error => {

          this.alertService.stopLoadingMessage();

          if (Utilities.checkNoNetwork(error)) {
            this.alertService.showStickyMessage(Utilities.noNetworkMessageCaption, Utilities.noNetworkMessageDetail, MessageSeverity.error, error);
            
          } else {
            const errorMessage = Utilities.getHttpResponseMessage(error);

            if (errorMessage) {
              this.alertService.showStickyMessage('Unable to store data', this.mapLoginErrorMessage(errorMessage), MessageSeverity.error, error);
            } else {
              this.alertService.showStickyMessage('Unable to store data', 'An error occured while saving data, please try again later.\nError: ' + Utilities.getResponseBody(error), MessageSeverity.error, error);
            }
          }

          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        });

  }


  mapLoginErrorMessage(error: string) {

    if (error === 'invalid_username_or_password') {
      return 'Invalid username or password';
    }

    if (error === 'invalid_grant') {
      return 'This account has been disabled';
    }

    return error;
  }
   

  ShowOTPpopup() {
    Swal.fire({
      title: 'Re-Sent Email Successfully!',
      icon: 'success',
      confirmButtonText: 'Ok',
      allowOutsideClick: false,
      allowEscapeKey: false,

      showLoaderOnConfirm: true,  // Show a loading spinner while the API call is in progress
      preConfirm: async (val) => {
        if (val) {

        }
      },
    }).then((result) => {
      let url = '/changerequest/';
      this.router.navigate([url]);
    });
  }

  handleDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.hasAttribute('encyrptID')) {
      const encryptID = target.getAttribute('encyrptID');
      this.handleViewClick(encryptID);
    }
    else if (target.hasAttribute('encyrptidresend')) {
      const encryptID = target.getAttribute('encyrptidresend');
      this.handleViewClickResend(encryptID);
    }
  }


  handleDocumentClickHJ(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.hasAttribute('encyrptID')) {
      const encryptID = target.getAttribute('encyrptID');
      let url = environment.hjPortalUrl + "/ICD_ACK/ICD_details.aspx?q=" + encryptID;
      // Open the URL in a new tab
      window.open(url, '_blank');
    }
  }

  ngAfterViewInit(): void {
    this._unlistenDocClick = this.renderer.listen('document', 'click', (event) => {
      if (event.target.hasAttribute("encyrptid")) {        
        this.router.navigate(["//icddetail/offcamp//" + event.target.getAttribute("encyrptid")]);
      }
      if (event.target.hasAttribute("encyrptidd")) {
        //this.router.navigate(["//icddetail/offcamp//" + event.target.getAttribute("encyrptid")]);
        let url = environment.hjPortalUrl + "/ICD_ACK/ICD_details.aspx?q=" + event.target.getAttribute("encyrptidd");
        // Open the URL in a new tab
        window.open(url, '_blank');
      }
      if (event.target.hasAttribute("encyrptidl")) {
        //this.router.navigate(["//icddetail/offcamp//" + event.target.getAttribute("encyrptid")]);
        let url = environment.hjPortalUrl + "/ICD_ACK/ICD_AddLoc.aspx?q=" + event.target.getAttribute("encyrptidl");
        // Open the URL in a new tab
        window.open(url, '_blank');
      }
      if (event.target.hasAttribute("encyrptidm")) {
        //this.router.navigate(["//icddetail/offcamp//" + event.target.getAttribute("encyrptid")]);
        let url = environment.hjPortalUrl + "/ICD_ACK/ICD_MoveLoc.aspx?q=" + event.target.getAttribute("encyrptidm");
        // Open the URL in a new tab
        window.open(url, '_blank');
      }
      if (event.target.hasAttribute("encyrptidresend")) {
        const encryptID = event.target.getAttribute('encyrptidresend');
        this.handleViewClickResend(encryptID);
      }

      // other click handlers only
       
     });

    // Add Bootstrap tooltip initialization for hover
    this.initializeTooltips();
  }

  ngOnDestroy(): void {
    if (this._unlistenDocClick) this._unlistenDocClick();
  }

  initializeTooltips(): void {
    setTimeout(() => {
      const tooltipElements = document.querySelectorAll('.next-step-tooltip');
      tooltipElements.forEach((element: any) => {
        const tooltipData = JSON.parse(element.getAttribute('data-tooltip'));
        const tooltipContent = this.generateTooltipContent(tooltipData);
        
        // Use Bootstrap popover for richer HTML on hover
        if (($ as any).fn.popover) {
          // destroy existing popover if any
          try { ($(element) as any).popover('dispose'); } catch (e) {}
          ($(element) as any).popover({
            content: tooltipContent,
            html: true,
            placement: 'top',
            trigger: 'hover',
            container: 'body'
          });
        } else if (($ as any).fn.tooltip) {
          try { ($(element) as any).tooltip('dispose'); } catch (e) {}
          ($(element) as any).tooltip({
            title: tooltipContent,
            html: true,
            placement: 'top',
            trigger: 'hover',
            container: 'body'
          });
        }
      });
    }, 100);
  }

  onToggleInsuranceUpdates(event: any) {
    this.showInsuranceUpdates = !!event.target.checked;

    // If hiding Insurance Updates while that reason is the active Request filter,
    // clear the filter — otherwise the reload would return 0 rows.
    if (!this.showInsuranceUpdates && this.selectedRequest === 'Insurance Update') {
      this.selectedRequest = null;
      this.filterColumnExact(3, null);
    }

    // Re-run the ajax source so the exclusion list (and card counts) are recomputed.
    if (this.datatableElement && this.datatableElement.dtInstance) {
      this.datatableElement.dtInstance.then((dtInstance: any) => dtInstance.ajax.reload());
    }
  }

  filterTableByStatus(status: string) {
    this.selectedFilter = status;

    // Get the DataTable instance using the DataTables jQuery selector
    const table = $('#tbldata').DataTable();

    // Update the search text in the "Request Status" column to filter by the clicked status
    table.column(4).search(status).draw();

    // Reinitialize tooltips after table is redrawn
    setTimeout(() => this.initializeTooltips(), 100);
  }

  // Distinct, sorted, non-empty values for a field across the loaded rows.
  private distinctSorted(rows: any[], field: string): string[] {
    const values = (rows || [])
      .map(r => (r && r[field] != null) ? String(r[field]).trim() : '')
      .filter(v => v !== '');
    return Array.from(new Set(values)).sort((a, b) => a.localeCompare(b));
  }

  // Exact-match column search (escaped) so a selected dropdown value matches the whole
  // cell only; passing null/empty clears that column's filter. Uses the same
  // table.column().search().draw() mechanism as the status cards, so pagination,
  // sorting and the Next Step hover popovers keep working.
  private filterColumnExact(colIndex: number, value: string): void {
    const table = $('#tbldata').DataTable();
    if (value == null || value === '') {
      table.column(colIndex).search('').draw();
    } else {
      const escaped = value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      table.column(colIndex).search(`^${escaped}$`, true, false).draw();
    }
    setTimeout(() => this.initializeTooltips(), 100);
  }

  filterTableByCompany(value: string) {
    this.filterColumnExact(1, value);
  }

  filterTableByOwner(value: string) {
    this.filterColumnExact(2, value);
  }

  filterTableByRequest(value: string) {
    this.filterColumnExact(3, value);
  }


}
